<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 80vh;">
    <div class="text-center">
      <h1 class="text-danger fw-bold" style="font-size: 2.2rem;">
        Página não encontrada
      </h1>

      <p class="mt-3 text-secondary" style="font-size: 1.2rem;">
        O endereço acessado não existe ou foi removido.
      </p>

      <p class="mt-4">
        <router-link
          to="/dashboard"
          class="btn btn-primary px-4 py-2"
        >
          Voltar ao Dashboard
        </router-link>
      </p>
    </div>
  </div>
</template>


<script>

import * as bootstrap from 'bootstrap';


import { defineComponent } from "vue";
import fintailapi from "../api";

export default defineComponent({
  name: "permissao",

  data() {
    return {
      cfg: [],
      selectedCfg: {
        id: null,
        key: "",
        value: "",
      },
    };
  },

  mounted() {
  
  },

  methods: {

  },
});
</script>
